<script setup>
import {Doughnut} from 'vue-chartjs'
import { Chart as ChartJS, CategoryScale, ArcElement, Tooltip } from "chart.js";
import 'chartjs-adapter-dayjs-4/dist/chartjs-adapter-dayjs-4.esm';
ChartJS.register(CategoryScale, ArcElement, Tooltip)



const props = defineProps({
  datacollection: {
    type: Array,
    default: () => [],
  },
  options: {
    type: Object,
    default: () => ({}),
  }
});

</script>

<template>
  <Doughnut
    :options="options"
    :data="datacollection"
  />
</template>